import React from 'react';
import { Box, Typography, Grid, Divider, CircularProgress } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';

const TopSection = ({
  selectedScenario,
  scenarios = [],
  translateContent = (value) => value,
  isLocalizationLoading = false
}) => {
  const { tr, isEnglish } = useLanguage();
  const currentScenario = scenarios.find(scenario => scenario.id === selectedScenario) || {};
  
  // Parse the description to get customer info and goal
  const parseDescription = (description) => {
    if (!description) return { customerInfo: '', goal: '' };
    const [customerInfo, goal] = description.split('\n\n目標：');
    return { customerInfo: customerInfo.replace('客戶資料：\n', ''), goal };
  };

  const { customerInfo, goal } = parseDescription(currentScenario.description);

  if (isEnglish && isLocalizationLoading) {
    return (
      <Box sx={{ mb: 2, p: 4, bgcolor: '#fff', borderRadius: 4, textAlign: 'center' }}>
        <CircularProgress size={24} />
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          Loading English scenario…
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      mb: 2,
      p: 2,
      bgcolor: '#fff',
      borderRadius: 4,
      boxShadow: '0 0 10px rgba(0,0,0,0.05)'
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
        <Box
          component="img"
          src={currentScenario.image}
          alt={currentScenario.name}
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            mr: 1.5,
            objectFit: 'cover'
          }}
        />
        <Box>
          <Typography variant="subtitle1" sx={{ 
            color: '#333',
            fontWeight: 500,
            lineHeight: 1.2
          }}>
            {translateContent(currentScenario.title || '')}
          </Typography>
          
          {/* Display tags if available in a more compact way */}
          {currentScenario.tags && currentScenario.tags.length > 0 && (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
              {currentScenario.tags.map((tag, index) => (
                <Box 
                  key={index}
                  sx={{
                    bgcolor: '#e3f2fd',
                    color: '#1976d2',
                    px: 1,
                    py: 0.25,
                    borderRadius: 1,
                    fontSize: '0.7rem',
                    fontWeight: 500
                  }}
                >
                  {translateContent(tag)}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>
      
      <Divider sx={{ my: 1 }} />
      
      <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
          <Box>
            <Typography variant="body2" gutterBottom sx={{ 
              fontWeight: 600,
              color: '#1976d2',
              mb: 0.5
            }}>
              {tr('理解客戶背景', 'Understand the Customer')}
            </Typography>
            <Typography variant="caption" sx={{ color: '#666', display: 'block' }}>
              {translateContent(customerInfo)}
            </Typography>
          </Box>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Box>
            <Typography variant="body2" gutterBottom sx={{ 
              fontWeight: 600,
              color: '#1976d2',
              mb: 0.5
            }}>
              {tr('引導對話', 'Guide the Conversation')}
            </Typography>
            <Typography variant="caption" sx={{ color: '#666', display: 'block' }}>
              {tr(
                '避免直接推銷，先瞭解客戶需求，建立信任感。',
                'Avoid a direct sales pitch. Learn about the customer\'s needs first and build trust.'
              )}
            </Typography>
          </Box>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Box>
            <Typography variant="body2" gutterBottom sx={{ 
              fontWeight: 600,
              color: '#1976d2',
              mb: 0.5
            }}>
              {tr('提出解決方案', 'Present a Solution')}
            </Typography>
            <Typography variant="caption" sx={{ color: '#666', display: 'block' }}>
              {translateContent(goal || '')}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TopSection;
